/* Knurlhouse: make in-page links such as /#faq work.
   Desktop: Horizon scrolls inside .page-wrapper and sets history.scrollRestoration to
   'manual', so the browser's own jump to a #fragment after navigation never happens.
   Phone: arriving from the menu drawer, Horizon's scroll lock/restore can reset the
   page to the top after the jump. So scroll the target into view ourselves, and retry
   briefly in case something resets it, but stop as soon as the visitor scrolls, and
   never override Horizon's own back/forward scroll restoration. */
(function () {
  var visitorScrolled = false;
  ['wheel', 'touchstart', 'keydown'].forEach(function (type) {
    window.addEventListener(type, function () { visitorScrolled = true; }, { passive: true, once: true });
  });

  function target() {
    if (!location.hash || location.hash.length < 2) return null;
    try {
      return document.getElementById(decodeURIComponent(location.hash.slice(1)));
    } catch (e) {
      return null;
    }
  }

  // Land the section's heading just under the sticky header, straight away. Horizon sets
  // scroll-behavior: smooth, which glided through the whole home page (and fired every reveal)
  // on the way to #faq, and section padding left a band of empty space above the heading.
  function headerBottom() {
    var v = parseFloat(getComputedStyle(document.body).getPropertyValue('--header-height'));
    return isNaN(v) ? 72 : v;
  }
  // Where the section's content starts: its top edge plus its top padding. Measuring the heading
  // itself was unreliable: headings play a wipe-in (translateY) on arrival, and the FAQ heading is
  // sticky, so it reported its pinned position and each check scrolled a little further.
  function contentTop(el) {
    return el.getBoundingClientRect().top + (parseFloat(getComputedStyle(el).paddingTop) || 0);
  }
  function jump(el) {
    var delta = contentTop(el) - (headerBottom() + 32);
    if (Math.abs(delta) < 2) return;
    var sc = scroller();
    sc.scrollTo({ top: sc.scrollTop + delta, behavior: 'instant' });
  }

  function scrollToHash(force) {
    var el = target();
    if (!el || (visitorScrolled && !force)) return;
    var top = contentTop(el);
    // Images above the section can still be loading and push it down after the first jump, so
    // the follow-up checks correct anything more than a few pixels off (until the visitor scrolls).
    if (force || Math.abs(top - (headerBottom() + 32)) > 6) jump(el);
  }

  // Horizon restores a saved position (history.state.scrollTop) only on Back/Forward or a reload
  // (scroll-container.js); then the visitor's place wins over the #fragment. A fresh visit can still
  // carry a stale scrollTop in Safari, so the navigation type decides, not the state alone.
  function horizonRestores(persisted) {
    if (!history.state || history.state.scrollTop == null) return false;
    if (persisted) return true;
    var nav = performance.getEntriesByType && performance.getEntriesByType('navigation')[0];
    return !!nav && (nav.type === 'back_forward' || nav.type === 'reload');
  }

  // Jump as soon as the page is parsed, not after every image has loaded (pageshow), so the
  // visitor never sees the page sitting at the top first.
  document.addEventListener('DOMContentLoaded', function () {
    if (horizonRestores(false)) return;
    scrollToHash(false);
  });

  window.addEventListener('pageshow', function (e) {
    if (horizonRestores(e.persisted)) return;
    requestAnimationFrame(function () {
      requestAnimationFrame(function () { scrollToHash(false); });
    });
    [300, 800, 1500, 2500].forEach(function (ms) {
      setTimeout(function () { scrollToHash(false); }, ms);
    });
  });

  // Back/Forward between /#faq and / is a same-page hash change. With Horizon's inner scroller the
  // browser can't restore the position, so the page stayed down at the footer and looked empty.
  // Remember where the visitor was before following an in-page link and return there (top by default).
  function scroller() {
    var pw = document.querySelector('.page-wrapper');
    if (pw && pw.scrollHeight > pw.clientHeight + 1 && getComputedStyle(pw).overflowY !== 'visible') return pw;
    return document.scrollingElement || document.documentElement;
  }
  var saved = {};
  function pageKey() { return location.href.split('#')[0]; }
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href*="#"]');
    if (a && !location.hash) saved[pageKey()] = scroller().scrollTop;
  }, true);

  // Any other same-page link (the desktop menu's FAQ while on /): jump without the smooth glide.
  document.addEventListener('click', function (e) {
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var a = e.target.closest && e.target.closest('a[href*="#"]');
    if (!a || a.closest('header-drawer') || a.target === '_blank') return;
    var url = new URL(a.href, location.href);
    if (url.origin !== location.origin || url.pathname !== location.pathname || url.search !== location.search || url.hash.length < 2) return;
    var el = document.getElementById(decodeURIComponent(url.hash.slice(1)));
    if (!el) return;
    e.preventDefault();
    if (location.hash !== url.hash) history.pushState(history.state, '', url.hash);
    jump(el);
  });

  // A same-page link in the phone menu (/#faq while on /) doesn't reload the page, so Horizon's
  // drawer stayed open and the page stayed scroll-locked. Close it, then jump to the section.
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('header-drawer a[href*="#"]');
    if (!a) return;
    var url = new URL(a.href, location.href);
    if (url.pathname !== location.pathname || url.search !== location.search) return;
    var drawer = a.closest('header-drawer');
    setTimeout(function () {
      if (drawer && typeof drawer.close === 'function') drawer.close();
      scrollToHash(true);
      setTimeout(function () { scrollToHash(true); }, 400);
    }, 0);
  });

  window.addEventListener('hashchange', function () {
    if (target()) { scrollToHash(true); return; }
    scroller().scrollTo({ top: saved[pageKey()] || 0, behavior: 'instant' });
  });
})();

/* Knurlhouse: the cart page's "Continue shopping" link (blocks/_cart-title.liquid) links to the
   Rings page. If the visitor came from a product or collection page on this site, go back there
   instead: history.back() keeps the chosen variant and scroll position; a new tab with no history
   opens that page's URL. Delegated, so it survives Horizon re-rendering the cart. */
(function () {
  document.addEventListener('click', function (e) {
    var link = e.target.closest && e.target.closest('[data-kh-continue]');
    if (!link || e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var ref;
    try { ref = new URL(document.referrer); } catch (err) { return; }
    if (ref.origin !== location.origin || !/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?(products|collections)\//i.test(ref.pathname)) return;
    e.preventDefault();
    if (history.length > 1) history.back();
    else location.href = ref.href;
  });
})();
